export const FeeUpdateConfig = ({ commit }, data) => {
  commit('FeeUpdateConfig', data)
}
export const changeLanguage = ({ commit }, data) => {
  commit('changeLanguage', data)
}
